import React from 'react';

/** Workspace hero — desk, keyboard, professional network mural */
const LOGIN_HERO_SRC = '/images/auth/login-hero-workspace.png';

interface AuthPinHeroPanelProps {
  t: (key: string) => string;
}

const AuthPinHeroPanel: React.FC<AuthPinHeroPanelProps> = ({ t }) => {
  return (
    <div className="hero-image-frame">
      <img
        src={LOGIN_HERO_SRC}
        alt={t('auth.loginHeroImageAlt')}
        className="hero-img"
        decoding="async"
        fetchpriority="high"
      />
    </div>
  );
};

export default AuthPinHeroPanel;
